export class OfficeEquipmentTypeInput {
    public name: string = '';
}
